<dx-popup
  #portalAnnouncementPopup
  [minWidth]="isSmallScreen ? popupWidth : undefined"
  [minHeight]="isSmallScreen ? popupHeight : undefined"
  [maxWidth]="popupMaxWidth"
  [maxHeight]="popupMaxHeight"
  [showTitle]="true"
  [dragEnabled]="false"
  [deferRendering]="true"
  [showCloseButton]="false"
  [resizeEnabled]="false"
  [shading]="true"
  [position]="popupPosition"
  [wrapperAttr]="{ class: 'portal-announcement-popup-wrapper' }"
  titleTemplate="titleTemplate"
  [(visible)]="portalAnnouncementVisible"
  (onHiding)="hide()"
  (onShowing)="populatePortalAnnouncements()"
  (onShown)="repaint()"
>
  <div *dxTemplate="let data of 'titleTemplate'" class="popup-header">
    <span class="popup-title">Announcements</span>
    <button class="popup-close-button" (click)="hide()">
      <app-icon name="close" size="24px" stroke="#121F38"></app-icon>
    </button>
  </div>
  <dx-box
    direction="col"
    class="cc-portal-announcement-container"
    width="100%"
    height="100%"
  >
    <dxi-item [ratio]="1">
      <dx-list
        [items]="announcements"
        width="100%"
        height="100%"
        noDataText="There are no announcements"
      >
        <div
          *dxTemplate="let info of 'item'"
          class="announcement-template-container"
        >
          <div class="announcement-release-date">
            {{ getFormattedDate(info.releaseDate) }}
          </div>
          <h5 class="announcement-title">{{ info.title }}</h5>
          <h6
            *ngIf="!!info?.context && info?.context.toUpperCase() !== 'GLOBAL'"
            class="announcement-context"
          >
            {{ info.context }}
          </h6>
          <div
            class="announcement-content"
            [innerHTML]="info.htmlContent | ccSafeHtml"
          ></div>
        </div>
      </dx-list>
    </dxi-item>
  </dx-box>
</dx-popup>

<dx-load-panel
  [position]="{ of: '#portalAnnouncementPopup' }"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
></dx-load-panel>
